module.exports = "<div class=\"container-hide-info-btn\" ng-click=\"$ctrl.clicked({$event: {hide: !$ctrl.isHide}})\">\n  <span class=\"text\" ng-if=\"!$ctrl.isHide\"><span class=\"icon icon-hide\"></span> {{'GLOBALS.BUTTON_ACTION.HIDE_INFO' | translate}}</span>\n  <span class=\"text\" ng-if=\"$ctrl.isHide\"><span class=\"icon icon-expand\"></span></span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlineHide/calendarInlineHide.html
// module id = 1493
// module chunks = 0